import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Privacy from 'pages/Privacy'

import Landing from '../pages/Landing'
import Signup from '../pages/Signup'
import Login from '../pages/Login'
import RecoverPassword from '../pages/RecoverPassword'
import Thanks from '../pages/Thanks'

const UnauthenticatedRoutes = () => (
  <Switch>
    <Route path="/privacy" component={Privacy} />
    <Route path="/iscriviti" component={Signup} />
    <Route path="/iscrizione-effettuata" component={Thanks} />
    <Route path="/accedi" component={Login} />
    <Route path="/recupera-password" component={RecoverPassword} />
    <Route path="/" exact component={Landing} />
    <Redirect from="/acquista" to="/accedi" />
    <Redirect to="/" />
  </Switch>
)

export default UnauthenticatedRoutes
